import * as React from 'react';

const NoResultsHeading = () => (
    <div className="noResultsHeading">
        <h2>No results</h2>
        <p>Try adjusting your filter settings, or clear all filters to start again.</p>
    </div>
)

export default NoResultsHeading;